import { db } from "@/api/firebase";
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import { Season } from "@/models/GameType";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { isEmpty } from "lodash";
import { GameWarning } from "@/models/Errors/GameWarning";
export default class QuestGameWarnings {
  mapPoi: QuestMapPoi[];
  questData: Quests[];
  gameUid: string;
  cityData: City;
  seasonData: Season;
  gameData: Game[];
  warnObject = {} as GameWarning;

  constructor(
    gameUid: string,
    mapPoi: QuestMapPoi[],
    questData: Quests[],
    cityData: City,
    seasonData: Season,
    gameData: Game[]
  ) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
    this.cityData = cityData;
    this.questData = questData;
    this.seasonData = seasonData;
    this.gameData = gameData;
  }

  checkGameWarnings(): GameWarning {
    this.countWarnIssues();
    this.countQuestWarnIssues();
    if (!isEmpty(this.warnObject)) {
      db.ref("games/" + this.gameUid + "/issues/warn/").set(this.warnObject);
    } else {
      db.ref("games/" + this.gameUid + "/issues/warn/").remove();
    }
    return this.warnObject;
  }

  private countWarnIssues(): void {
    let count = 0;
    this.mapPoi.forEach((x: QuestMapPoi) => {
      if (x.issues?.warn?.poi_difference !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.warnObject.poi_difference = {
        active: true,
        txt: { en: "> " + count + " of the POIs differ from the template " },
      };
    } else {
      if (this.warnObject.poi_difference !== undefined) {
        delete this.warnObject.poi_difference;
      }
    }
  }
  private countQuestWarnIssues(): void {
    let count = 0;
    this.questData.forEach((x: Quests) => {
      if (x.issues?.warn?.quest_difference !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.warnObject.quest_difference = {
        active: true,
        txt: { en: "> " + count + " of the Quest differ from the template " },
      };
    } else {
      if (this.warnObject.quest_difference !== undefined) {
        delete this.warnObject.quest_difference;
      }
    }
  }
}
